import React from "react";
import * as DIAG from "storm-react-diagrams";
import map from "lodash/map";

export default class CustomLinkLayerWidget extends DIAG.LinkLayerWidget {
    /**
     * Normal link layer widget
     * @module CustomLinkLayerWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {};
    }

    /**
     * Get the port position for a given port attached to node, based on node's port position cache
     * @param {Object} port Port model
     * @returns {Object}
     */
    getPortCenter(port){
        if (port.name === "top"){
            //DEVDES2-61
            //return {x: port.getParent().x + 70, y: port.getParent().y};
            return {x: port.getParent().x + 90, y: port.getParent().y};
        }
        if (port.name === "left"){
            return {x: port.getParent().x, y: port.getParent().y + 30};
        }
        if (port.name === "right"){
            //DEVDES2-61
            //return {x: port.getParent().x + 140, y: port.getParent().y + 30};
            return {x: port.getParent().x + 180, y: port.getParent().y + 30};
        }
        if (port.hasOwnProperty("centerOffset")){
            return {
                x: port.getParent().x + port.centerOffset.x,
                y: port.getParent().y + port.centerOffset.y
            }
        } else {
            throw "";
        }
    };

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const diagramModel = this.props.diagramEngine.getDiagramModel();
        return (
            <svg
                style={{
                    transform:
                    "translate(" +
                    diagramModel.getOffsetX() +
                    "px," +
                    diagramModel.getOffsetY() +
                    "px) scale(" +
                    diagramModel.getZoomLevel() / 100.0 +
                    ")",
                    width: "100%",
                    height: "100%"
                }}
            >
                {//only perform these actions when we have a diagram
                    this.props.diagramEngine.canvas &&
                    map(diagramModel.getLinks(), link => {
                        if (link.sourcePort !== null) {
                            //generate a point
                            try {
                                link.points[0].updateLocation(this.getPortCenter(link.sourcePort));
                                this.props.diagramEngine.linksThatHaveInitiallyRendered[link.id] = true;
                            } catch (ex) {
                            }
                        }
                        if (link.targetPort !== null) {
                            try {
                                link.points[link.points.length - 1].updateLocation(this.getPortCenter(link.targetPort));
                                this.props.diagramEngine.linksThatHaveInitiallyRendered[link.id] = true;
                            } catch (ex) {
                            }
                        }

                        //generate links
                        const generatedLink = this.props.diagramEngine.generateWidgetForLink(link);
                        if (!generatedLink) {
                            return null;
                        }

                        return (
                            <DIAG.LinkWidget key={link.getID()} link={link} diagramEngine={this.props.diagramEngine}>
                                {generatedLink}
                            </DIAG.LinkWidget>
                        );
                    })}
            </svg>
        );
    }
}
